import { Parsing } from "./parsing";

class SkIf extends Parsing {
  comment: Comment;
  ref: any;
  exp: any;
  isRemove = false;

  constructor(
    private elem: HTMLElement,
    private attr: string,
    private module: any
  ) {
    super();
    this.comment = document.createComment(`sk:if ${this.attr}`);
    this.elem.parentNode.insertBefore(this.comment, this.elem);
    this.ref = this.elem.cloneNode(true);
    this.exp = Parsing.expression(attr);
    setTimeout(() => {
      this.update();
    }, 10);
  }

  update(): void {
    const value = this.exp.call(this.module);
    if (value) {
      if (!this.elem) {
        this.elem = this.ref.cloneNode(true);
      }
      this.comment.parentNode.insertBefore(this.elem, this.comment);
      this.isRemove = false;
    } else {
      if (!this.isRemove) {
        this.isRemove = true;
        try {
          this.comment.parentNode.removeChild(this.elem);
        } catch (e) {
          console.log(this.elem);
        }
      }
    }
  }
}

export { SkIf };
